import { LabelCheckboxComponent } from './../label-checkbox/label-checkbox.component';
import {
  ComponentFactoryResolver, ComponentRef, Directive, Input, OnInit,
  ViewContainerRef, Output, EventEmitter, Renderer2
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../../field.interface";
import { InputComponent } from "../input/input.component";
import { ButtonComponent } from "../button/button.component";
import { SelectComponent } from "../select/select.component";
import { DateComponent } from "../date/date.component";
import { RadiobuttonComponent } from "../radiobutton/radiobutton.component";
import { CheckboxComponent } from "../checkbox/checkbox.component";
import { HiddenComponent } from "../hidden/hidden.component";

const componentMapper = {
  input: InputComponent,
  hidden: HiddenComponent,
  button: ButtonComponent,
  select: SelectComponent,
  date: DateComponent,
  radiobutton: RadiobuttonComponent,
  checkbox: CheckboxComponent,
  labelcheckbox: LabelCheckboxComponent
};

@Directive({
  selector: '[dynamicField]'
})

export class DynamicFieldDirective implements OnInit {
  @Input() field: FieldConfig;
  @Input() group: FormGroup;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  componentRef: any;
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    const factory = this.resolver.resolveComponentFactory(
      componentMapper[this.field.type]
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.field = this.field;
    this.componentRef.instance.group = this.group;
    if (this.componentRef.instance.change) {
      this.componentRef.instance.change.subscribe((event) => {
        var that = this;
        that.change.emit(event);
      });
    }
  }
  
  onChange(event) {
    this.change.emit(event);
  }
}